// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ClientsResponse } from '../../shared/select-client-list/models/clients-response';
import { HttpClient, HttpParams } from '@angular/common/http';
import { shareReplay } from 'rxjs/operators';
import { ConfigService } from '@coa/app/core/services/config.service';

@Injectable({
  providedIn: 'root',
})
export class ClientsService {

  private getClientsRequest: Observable<ClientsResponse>;

  constructor(
    private httpClient: HttpClient,
    private configService: ConfigService,
  ) {
  }

  getClients(): Observable<ClientsResponse> {

    if (!this.getClientsRequest) {
      const url = this.configService.getConfig().clientServiceApi + '/clients';
      const params = new HttpParams()
        .set('page', '0')
        .set('size', '1000')
        .set('countryIds', this.configService.getConfig().enabledCountryIds.join(','));
      this.getClientsRequest = this.httpClient.get<ClientsResponse>(url, {params}).pipe(shareReplay(1));
    }

    return this.getClientsRequest;
  }

  clearCache() {
    this.getClientsRequest = undefined;
  }
}
